import { createReducer, on } from '@ngrx/store';
import { UserState, userUpdate, setUserSubscription } from '@cmi/store/user';

export const userInitialState = {
  permissions: [] as string[]
} as UserState;

export const userReducer = createReducer(
  userInitialState,
  on(
    userUpdate,
    (_state, prop) =>
      ({
        ...prop.userProfile,
        permissions: prop.permissions,
        isUserSubscribed: prop.isUserSubscribed
      }) as UserState
  ),
  on(
    setUserSubscription,
    (state, { isUserSubscribed }) => ({ ...state, isUserSubscribed }) as UserState
  )
);
